/**
 * output alt
 */

export function output_alt() {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.fs-c-productPlainImage').forEach(function(element) {
      var img = element.querySelector('img');
      img.classList.add('pc');
      var alt = img.getAttribute('alt');
      var p = document.createElement('p');
      p.innerHTML = alt;
      element.appendChild(p);
    });
  });
}
